import React from 'react'
import { Link as ReactLink }from 'react-router-dom'
import Box from '@mui/material/Box'

export default function PolicyPrivacy() {
    return (
        <>
            <Box
            display="flex" 
            flexDirection="column" 
            alignItems="left" 
            justifyContent="flex-start" 
            sx={{ p: 7 }}
            style={{ width: '100%', height: '200px', backgroundImage: 'url("/images/events/banner_top.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
            >
                <ReactLink to='/'>
                    <Box style={{ paddingBottom: '50px' }}>
                        <img alt="logo" src="/images/events/home.png" />
                    </Box>
                </ReactLink>
                <Box display="flex" flexDirection="row" >
                    <span style={{color: 'white', fontSize: '25px', paddingRight: '10px'}}>Nice to meet u,</span>
                    <img height="28px" alt="logo" src="/images/events/logo_white.png" />
                </Box>
            </Box>
            <div style={{padding: 20}}>
                <div style={{fontSize: '14px', marginBottom: '10px'}}>
                    ​개인정보 처리방침
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    (주)러닝포인트 및 어플리케이션 모아 mooa (이하 “모아”라고 함)은 개인의 정보보호를 중요시하며 「개인정보보호법」, 「정보통신망 이용 촉진 및 정보보호 등에 관한 법률」, 「통신비 밀 보호법」등 개인 정보보호와 관련한 법률 또는 지침 및 정보통신서비스 제공자가 준수하여야 할 관련 법령상의 개인 정보보호 규정을 준수하고 있습니다. 
                    이에 “모아”은 개인정보 보호법 제30조 및 정보통신망 이용 촉진 및 정보보호 등에 관한 법률 제27조의 제2항 규정에 의하여 해당 홈페이지에 별도의 개인정보처리방침을 정하여 운영하고 있습니다. 
                    이러한 방침 은 관련 법률 및 정부 지침의 변경과 "모아" 내부 방침의 변경에 의하여 수시로 변경될 수 있으며, 개인정보처리방침이 변경될 경우 변경사항은 "모아" 홈페이지 공지사항(또는 개별 공지)를 통하여 게시할 것입니다. 
                    관련된 사항에 의문이 있으실 경우는 언제라도 담당자에게 문의하시거나, 홈페이지를 방문하여 열람하실 수 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    본 개인정보 처리방침에서 사용된 용어의 의미는 특별한 규정이 없는 한 “모아” 이용약관 및 일반 상관례와 동일합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    1. 개인정보 수집에 대한 동의
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    “모아”은 이용자들이 회사의 개인정보 처리방침 또는 이용약관의 내용에 대하여 「동의」 버튼 또는 「취소」 버튼을 클릭할 수 있는 절차를 마련하여, 「동의」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    2. 수집하는 개인정보의 항목 및 수집방법
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① 수집하는 개인 정보의 항목
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    가. “모아”은 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 최초 회원가입 당시 아래와 같은 개인 정보를 수집하고 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    i. 이메일주소 (로그인 아이디)
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ii. 비밀번호
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    나. 서비스 이용과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    i) 기본적으로 수집되는 정보
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ◎ 필수 항목 : 이메일, 아이디, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록, IP 주소, 기기 정보
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② 개인 정보 수집 방법
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    “모아”은 다음과 같은 방법으로 개인 정보를 수집합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    가. “모아”가 제공하는 서비스 프로그램을 실행 또는 사용함으로써 자동으로 수집
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    나. 서비스 가입이나 사용 중 이용자의 자발적 제공을 통한 수집
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    다. 홈페이지, 모바일 애플리케이션, 모바일 웹페이지, 서면, 팩스, 전화, 고객센터 문의하기, 이벤트 응모
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    라. 카카오, 네이버 등 타사의 계정으로 로그인 시 이용자 고유 식별자, 이메일주소, 휴대전화 번호를 필수 항목으로 수집
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    3. 개인 정보의 수집 및 처리목적
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① 재화 또는 서비스 제공
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    서비스 제공, 콘텐츠 제공, 맞춤서비스 제공 등을 처리
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② 회원관리
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    회원제 서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인식별, 불량 회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 가입 및 가입 횟수 제한, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록 보존, 불만 처리 등 민원처리, 고지사항 전달
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ③ 신규 서비스 개발 및 마케팅ᆞ광고에의 활용
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여 기회 제공, 접속 빈도 파악, 회원의 서비스 이용에 대한 통계
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ➃ 고충처리
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    민원인의 신원 확인, 민원사항 확인, 사실 조사를 위한 연락.통지, 처리결과 통보 등의 목적
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    4. 일부 서비스의 취급 위탁
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① “모아”은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁할 수 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    1. 전화 상담센터 운영
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 위탁받는 자 (수탁자) : “모아” 고객센터
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 위탁하는 업무의 내용 : 전화 상담 응대, 부서 및 직원 안내 등
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② “모아”은 위탁계약 체결시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    인정보 처리금지, 기술적.관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리.감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    ③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    5. 개인 정보의 보유 및 이용기간
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① “모아”은 법령에 따른 개인정보 보유.이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유 및 이용기간 내에서 개인정보를 처리, 보유합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    1. 앱 서비스 회원 가입 및 관리 : 앱 서비스 탈퇴시까지, 다만, 다음의 사유에 해당하는 경우 에는 해당 사유 종료시까지
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    가. 관계 법령 위반에 따른 수사.조사 등이 진행 중인 경우에는 해당 수사.조사 종료시까지 나. 앱 이용에 따른 채권.채무관계 잔존시에는 해당 채권.채무관계 정산시까지
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    2. 재화 또는 서비스 제공 : 재화.서비스 공급 완료 및 요금결제.정산 완료시까지, 다만, 다음 의 사유에 해당하는 경우에는 해당 기간 종료시까지
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    가. 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시.광고, 계약내용 및 이행 등 거래에 관한 기록
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 표시.광고에 관한 기록 : 6월
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년 - 소비자 불만 또는 분쟁처리에 관한 기록 : 3년
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    나. 통신비밀보호법 제41조에 따른 통신사실확인자료 보관
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 가입자 전기통신일시, 개시.종료시간, 상대방 가입자번호, 사용도수, 발신기지국 위치추적자료 : 1년
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 : 3개월
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    다. 정보통신망 이용촉진 및 정보보호 등에 관한 법률 시행령 제29조에 따른 본인확인정보 : 정보게시 종료일로부터 6개월
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    6. 개인 정보 파기절차 및 방법
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① “모아”은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불 구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    1. 파기절차
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    2. 파기방법
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    회사는 전자적 파일 형태로 기록.저장된 개인정보는 기록을 재생할 수 없도록 로우레밸포멧 (Low Level Format) 등의 방법을 이용하여 파기하며, 종이 문서에 기록.저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    7. 개인정보의 안전성 확보조치
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    “모아”은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① 관리적 조치 : 내부관리계획 수립.시행, 정기적 직원 교육 등
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정 보 등의 암호화, 보안프로그램 설치
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    ③ 물리적 조치 : 전산실, 자료보관실 등의 접근통제
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    8. 개인 정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    “모아”은 이용자에게 특화된 맞춤 서비스를 제공하기 위해서 이용자들의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)' 등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장되기도 합니다. "모아"은
                    다음과 같은 목적을 위해 쿠키를 사용합니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① 쿠키 등 사용목적
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② 쿠키 설정 거부 방법
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 
                    설정 방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 - 인터넷 옵션 - 개인 정보 단, 쿠키 설치를 거부하였을 경우 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    9. 개인정보 보호책임자
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① 회사는 개인정보처리에 관한 업무를 총괄해서 책임지고, 개인정보처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ▶ 개인정보 보호책임자
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    성명 : 박태훈
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    직책 : ceo
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    연락처 : info@runpoint.com
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ※ 개인정보 보호 담당부서로 연결됩니다. 
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ▶ 개인정보 보호 담당부서
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    부서명 : 경영
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    담당자 : 박태훈
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    연락처 : info@runpoint.com
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    ② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    10. 일부 서비스의 취급 위탁
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① "모아"은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁 할 수 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    1. 전화 상담센터 운영
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 위탁받는 자 (수탁자) : “모아” 고객센터
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    - 위탁하는 업무의 내용 : 전화 상담 응대, 부서 및 직원 안내 등
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ② “모아”은 위탁계약 체결시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개 인정보 처리금지, 기술적.관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리.감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는 지를 감독하고 있습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    ③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    11. 개인정보 처리방침 변경
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    ① 이 개인정보 처리방침은 2022. 06. 10.에 제정하여 같은 날부터 적용됩니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    ② 회사가 개인정보 처리방침을 개정하는 경우 회사 홈페이지에 게시하고, 그 이력을 남깁니다.
                </div>
                <div style={{fontSize: '12px', marginBottom: '20px'}}>
                    12. 약관수정
                </div>
                <div style={{fontSize: '12px', marginBottom: '10px'}}>
                    “모아”는 법률이나 “모아” 서비스의 변경사항을 반영하기 위한 목적 등으로 본 약관 이나 각 “모아” 서비스 고객센터의 “모아” 서비스 이용방법, 해당 안내 및 고지사항을 수정할 수 있습니다. 
                    본 약관이 변경되는 경우 “모아” 변경 사항을 개별 “모아” 서비스 초기화면에 게시하며, 변경된 약관은 게시한 날로부터 7일 후부터 효력이 발생합니다.
                    “모아”은 변경된 약관을 게시한 날로부터 효력이 발생되는 날까지 약관변경에 대한 사용 자의 의견을 기다리겠습니다. 
                    위 기간이 지나도록 사용자의 의견이 “모아”에 접수되지 않으면, 사용자가 변경된 약관에 따라 서비스를 이용하는 데에 동의하는 것으로 보겠습니다. 
                    사용자가 변경된 약관에 동의하지 않는 경우 변경된 약관의 적용을 받는 해당 서비스의 제공이 더 이상 불가능하게 됩니다.
                </div>
            </div>
        </>
    )
}
